export interface IApplicationDetailDto {
  merchants: Array<any> | null;
  totalNumMerchants: number | null;
  client_id: string | null;
  client_secret: string | null;
}

export class ApplicationDetails implements IApplicationDetailDto {
  public merchants: Array<any> | null;
  public totalNumMerchants: number | null;
  public client_id: string | null;
  public client_secret: string | null;

  constructor(merchants: Array<any> | null, totalNumMerchants: number | null, client_id: string | null, client_secret: string | null) {
    this.merchants = merchants;
    this.totalNumMerchants = totalNumMerchants;
    this.client_id = client_id;
    this.client_secret = client_secret;
  }
}